import { Avatar, Flex } from 'antd'
import { FC } from 'react'
import { Link } from 'react-router-dom'

interface UserCellProps {
    username: string
}

const UserCell: FC<UserCellProps> = ({ username }) => {
    return (
        <Link to={'#'}>
            <Flex gap={6} align={'center'}>
                <Avatar size={'small'} /> {username}
            </Flex>
        </Link>
    )
}

export default UserCell
